import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  return <section className="py-10 px-4" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-10" data-id="element-15">
            <div className="inline-block bg-red-500/10 border border-red-500/20 rounded-full px-4 py-2 mb-5" data-id="element-16">
              <span className="text-red-400 font-bold tracking-wide uppercase text-sm" data-id="element-17">
                🎁 GRATIS POR EL DÍA DE HOY
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-18">
              Llevate estos 5 bonos exclusivos
            </h2>
            <p className="text-lg md:text-xl text-slate-400" data-id="element-19">
              Herramientas prácticas para acelerar tu aprendizaje en el
              consultorio.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-5 max-w-4xl mx-auto mb-5" data-id="element-20">
          <FadeIn delay={0.1} data-id="element-21">
            <div className="bg-gradient-to-b from-slate-800 to-slate-900 border border-cyan-500/30 p-6 md:p-7 rounded-3xl h-full relative overflow-hidden group" data-id="element-22">
              <div className="absolute top-0 right-0 w-24 h-24 bg-cyan-500/10 rounded-full blur-xl group-hover:bg-cyan-500/20 transition-colors" data-id="element-23"></div>
              <div className="text-4xl mb-3" data-id="element-24">🗺️</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-25">
                Mapa del Cuerpo Humano en Movimiento
              </h3>
              <p className="text-sm md:text-base text-slate-400 mb-4" data-id="element-26">
                Un mapa visual completo del cuerpo humano con los puntos clave
                de movimiento para entender cómo aplicar el tape en cada zona.
              </p>
              <div className="text-sm font-bold text-lime-400 mt-auto" data-id="element-27">
                Valor: $9.990 (Hoy GRATIS)
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-28">
            <div className="bg-gradient-to-b from-slate-800 to-slate-900 border border-cyan-500/30 p-6 md:p-7 rounded-3xl h-full relative overflow-hidden group" data-id="element-29">
              <div className="absolute top-0 right-0 w-24 h-24 bg-cyan-500/10 rounded-full blur-xl group-hover:bg-cyan-500/20 transition-colors" data-id="element-30"></div>
              <div className="text-4xl mb-3" data-id="element-31">📐</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-32">
                Guía Visual de Movimientos Básicos
              </h3>
              <p className="text-sm md:text-base text-slate-400 mb-4" data-id="element-33">
                Ilustraciones claras de los movimientos fundamentales que
                necesitás dominar para evaluar y aplicar vendajes con precisión.
              </p>
              <div className="text-sm font-bold text-lime-400 mt-auto" data-id="element-34">
                Valor: $7.990 (Hoy GRATIS)
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-35">
            <div className="bg-gradient-to-b from-slate-800 to-slate-900 border border-cyan-500/30 p-6 md:p-7 rounded-3xl h-full relative overflow-hidden group" data-id="element-36">
              <div className="absolute top-0 right-0 w-24 h-24 bg-cyan-500/10 rounded-full blur-xl group-hover:bg-cyan-500/20 transition-colors" data-id="element-37"></div>
              <div className="text-4xl mb-3" data-id="element-38">🦴</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-39">
                Anatomía Funcional para la Práctica Kinesiológica
              </h3>
              <p className="text-sm md:text-base text-slate-400 mb-4" data-id="element-40">
                Una guía de anatomía funcional orientada a la práctica real,
                para que entiendas la relación entre estructura y movimiento.
              </p>
              <div className="text-sm font-bold text-lime-400 mt-auto" data-id="element-41">
                Valor: $11.990 (Hoy GRATIS)
              </div>
            </div>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 gap-5 max-w-3xl mx-auto" data-id="element-42">
          <FadeIn delay={0.4} data-id="element-43">
            <div className="bg-gradient-to-b from-slate-800 to-slate-900 border border-cyan-500/30 p-6 md:p-7 rounded-3xl h-full relative overflow-hidden group" data-id="element-44">
              <div className="absolute top-0 right-0 w-24 h-24 bg-cyan-500/10 rounded-full blur-xl group-hover:bg-cyan-500/20 transition-colors" data-id="element-45"></div>
              <div className="text-4xl mb-3" data-id="element-46">🏋️</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-47">
                Mini Guía de Integración con Ejercicio Terapéutico
              </h3>
              <p className="text-sm md:text-base text-slate-400 mb-4" data-id="element-48">
                Aprendé a combinar KinesioTaping con ejercicio terapéutico para
                potenciar los resultados de cada sesión con tus pacientes.
              </p>
              <div className="text-sm font-bold text-lime-400 mt-auto" data-id="element-49">
                Valor: $9.990 (Hoy GRATIS)
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-50">
            <div className="bg-gradient-to-b from-slate-800 to-slate-900 border border-cyan-500/30 p-6 md:p-7 rounded-3xl h-full relative overflow-hidden group" data-id="element-51">
              <div className="absolute top-0 right-0 w-24 h-24 bg-cyan-500/10 rounded-full blur-xl group-hover:bg-cyan-500/20 transition-colors" data-id="element-52"></div>
              <div className="text-4xl mb-3" data-id="element-53">📖</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-54">
                Atlas de Casos Frecuentes para Estudiantes
              </h3>
              <p className="text-sm md:text-base text-slate-400 mb-4" data-id="element-55">
                Una referencia visual rápida con los casos clínicos más comunes
                que vas a encontrar en tus prácticas y primeros pacientes.
              </p>
              <div className="text-sm font-bold text-lime-400 mt-auto" data-id="element-56">
                Valor: $7.990 (Hoy GRATIS)
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}